export const userIdErrMsg = 'Your login id/ email address is incorrect';
export const passwordErrMsg = 'Your Password is incorrect';

export const loginErrors = {
	PASSWORD_EXPIRED: 'Login_3',
	ACCOUNT_LOCKED: 'Login_4',
	FIRST_TIME_LOGIN: 'Login_11',
	AUTHENTICATION: 'Login_2',
};

export const defaultErrorDetails = {
	code: loginErrors.AUTHENTICATION,
	message: '',
	links: ['/forgotPassword'],
	linkTexts: ['Forgot Password'],
};

export const LinkCodes = [loginErrors.PASSWORD_EXPIRED, loginErrors.ACCOUNT_LOCKED, loginErrors.FIRST_TIME_LOGIN];

export const changePasswordType = {
	FORGOT_PASSWORD: 'FORGOT_PASSWORD',
	RESET_PASSWORD: 'RESET_PASSWORD',
};

export const passwordRecovery = {
	FORGOT_PASSWORD: 'FORGOT PASSWORD',
};

export const loginText = {
	LOGIN_HEADER: 'Login to your Company Account',
	LOGIN_TEXT: 'Login ID / Email Address',
	PLACEHOLDER_TEXT: 'Enter your login id or email address',
};

export const ctaText = {
	CTA_NEXT: 'CONTINUE',
	CTA_LOGIN: 'LOGIN',
};
export const notificationText = {
	EXPENSE_TITLE: 'Expense Requests',
	EXPENSE_SUBTITLE: ' Awaiting Approval',
	EXPENSE_DESCRIPTION: 'Review and approve pending expense requests',
	EXPENSE_HIGHLIGHT: 'Awaiting Approval',
};

export const notificationConstants = {
	NOTIFICATION_ENABLED: 'Y',
};

export const GOOGLE_MAPS_KEY = { KEY: 'AIzaSyDnk1SaxYbYkmudkUILMFgYe9FykClD5Mk' };
